import angular from "angular";

import "../../services/cart";
import "../../services/orders";
import "./receipt-product";

angular.module("folkeuni").component("receipt", {
    bindings: {
        guid: "@",
        orderId: "@",
        siteId: "@",
        siteName: "@",
        productIds: "@",
    },
    controller: function ($timeout, Cart, Orders) {
        var $ctrl = this;
        $ctrl.order = {};
        $ctrl.formattedDate = "";

        $ctrl.$onInit = function () {
            $ctrl.handleOrderProducts()
            Cart.customerInfoLocalStorageClear();
            Orders.getOrderByIdAndGuid($ctrl.orderId, $ctrl.guid).then(
                function (orderObj) {
                    $ctrl.order = orderObj;
                    $ctrl.formattedDate = window.formatDates(orderObj.createdDate, null, false);

                    //   $timeout(function () {
                    // For Google Tag Manager

                    window.dataLayer = window.dataLayer || [];
                    if ($ctrl.siteId == 1) {
                        var fbItem = {
                            event: "receiptProduct",
                            productId: [],
                            totalPrice: $ctrl.order.totalAmountNotFormatted
                        };
                    }
                    var analyticsEcommerceObj = {
                        event: "transactionComplete",
                        ecommerce: {
                            purchase: {
                                actionField: {
                                    id: $ctrl.order.id, // Transaction ID. Required for purchases and refunds.
                                    affiliation: $ctrl.siteName,
                                    revenue: $ctrl.order.totalAmountNotFormatted, // Total transaction value (incl. tax and shipping)
                                    tax: "0",
                                    shipping: "0",
                                    coupon: ""
                                },
                                products: []
                            }
                        }
                    };
                    for (var i in $ctrl.order.lines) {
                        //  console.log($ctrl.order.lines[i]);
                        var currentProduct = $ctrl.order.lines[i];
                        //GoogleTagManager
                        if ($ctrl.siteId == 1) {
                            fbItem.productId.push(currentProduct.productId);
                        }
                        var currentProductObj = {
                            name: currentProduct.productName,
                            id: currentProduct.productVisibleId,
                            price: currentProduct.analyticsAmount,
                            brand: "",
                            category: currentProduct.analyticsCategory,
                            quantity: currentProduct.quantity,
                            variant: ""
                        };

                        analyticsEcommerceObj.ecommerce.purchase.products.push(currentProductObj);
                    }
                    if (window.dataLayer && $ctrl.siteId == 1) {
                        window.dataLayer.push(fbItem);
                    }

                    window.dataLayer.push(analyticsEcommerceObj);

                    var google_conversion_id = 960045977;
                    var google_conversion_language = "en";
                    var google_conversion_format = "3";
                    var google_conversion_color = "ffffff";
                    var google_conversion_label = "2DvtCL38oGAQmcfkyQM";
                    var google_conversion_value = $ctrl.totalAmountNotFormatted;
                    var google_conversion_currency = "DKK";
                    var google_remarketing_only = false;

                    //     }, 500);
                },
                function (errorResponse) {}
            );
        };

        $ctrl.handleOrderProducts = () => {
            var searchParams = new URLSearchParams(location.search);
            var productIds = $ctrl.productIds.split(",");
            searchParams.delete('p');
            productIds.forEach(x => searchParams.append('p', x));
            history.replaceState && history.replaceState(null, "", location.pathname + '?' + searchParams.toString());
        }
    },
    templateUrl: "/shop-dist/templates/receipt.html",
    transclude: true
});
